import React from "react";
import { Link } from "react-router-dom";

function Navbar() {
  return (

<>

 <style>
        {`
          .bsnav {
            position: relative !important;
            z-index: 9999;
          }

          .navbar {
            position: relative !important;
            z-index: 9999;
          }

          .bsnav-mobile {
            z-index: 9999;
          }
        `}
      </style>

    
    <nav className="navbar navbar-expand-lg bsnav bsnav-sticky bsnav-sticky-slide top-menu menu-two">
      <div className="container">

        <Link className="navbar-brand" to="/">
          <img
            src="/assets/img/logo2.png"
            alt="121 Bharat Business Tycoon Chamber"
          />
        </Link>

        <button  className="navbar-toggler toggler-spring"
          type="button"
          data-toggle="collapse"
          data-target="#navbarMenu"
          aria-controls="navbarMenu"
          aria-expanded="false"
          aria-label="Toggle navigation"
>
  <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse justify-content-md-end" id="navbarMenu">
          <ul className="navbar-nav navbar-mobile mr-0">

            <li className="nav-item active">
              <Link className="nav-link" to="/">
                Home
              </Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/about">
                About Us
              </Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/OurTeam">
                Our Team
              </Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/MembershipCategories">
                Membership Categories
              </Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="#">
                Contact Us
              </Link>
            </li>

          </ul>
        </div>

      </div>
    </nav>


    </>
  );
}

export default Navbar;